import React from "react";
import { useTranslation } from "react-i18next";
import { Chip } from "@nextui-org/react";
import { MdAccessTime } from "react-icons/md";
import CustomCopyToClipboard from "../../../components/Kit/CustomCopyToClipboard";
import AStarGradeDisplay from "../../../components/Kit/AStarGradeDisplay";

const HeaderBar = ({
  title,
  item_id,
  displayable_id,
  call_purpose,
  is_incoming_call,
  overall_grade,
  duration_label,
  actions_menu,
}) => {
  const { t } = useTranslation();
  return (
    <div className="px-8 pt-8 pb-4">
      <div className="flex items-center justify-between mb-3">
        <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
        <div className="flex items-center gap-2">{actions_menu}</div>
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        <CustomCopyToClipboard
          copyText={item_id}
          displayText={displayable_id}
          displayClassName="text-sm text-gray-600"
          wrapperClassName="!px-1 !py-0"
        />
        <div className="w-px h-4 bg-gray-200" />
        <div className="flex items-center gap-2">
          {call_purpose && (
            <Chip
              size="sm"
              variant="flat"
              className="bg-primary/10 text-primary"
            >
              {call_purpose}
            </Chip>
          )}
          <Chip
            size="sm"
            variant="dot"
            classNames={{ base: "bg-success-100 border-none", dot: "bg-success-500" }}
          >
            {is_incoming_call ? t("Entrant") : t("Sortant")}
          </Chip>
          {duration_label && (
            <span
              className="flex items-center gap-1 text-sm text-gray-600"
              title={t("Durée de l'appel")}
            >
              <MdAccessTime
                size={16}
                className="text-gray-400"
              />
              {duration_label}
            </span>
          )}
          <AStarGradeDisplay grade={overall_grade} />
        </div>
      </div>
    </div>
  );
};

export default HeaderBar;
